export interface IAdminTerminalsState {}

const initialState: IAdminTerminalsState = {}
export function adminTerminalsReducer(
  state: IAdminTerminalsState = initialState,
  action: any,
): IAdminTerminalsState {
  switch (action.type) {
    default:
      return state
  }
}
